// @ts-nocheck
import axios from 'axios';
import API_ENDPOINTS from '../../../../../const/ApiEndPoints';

export const getIsEntityAvailable = (params = {}) => {
  const res = axios.get(
    `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.MODEL_AVAILABLE}`,
    { params, loader: false }
  );
  return res;
};

export const getEntityTypeMetadata = (params = {}) => {
  const res = axios.get(
    `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.DYNAMIC_ENTITY_TYPE}`,
    { params, loader: false }
  );
  return res;
};

export const getEntityMetaData = ({
  entityId = '',
  entityType = '',
  context = {},
} = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.ENTITY_META_DATA}`,
      {
        params: {
          entityId,
          entityType,
          context: JSON.stringify(context),
        },
        loader: false,
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const getStateDetails = (params = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_STATE_DETAILS}`,
      {
        params,
        loader: false,
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const getAttributeDetails = (params = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.ATTRIBUTE_DETAILS}`,
      {
        params,
        loader: false,
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const getAttributeComments = (params = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_ATTRIBUTES_COMMENTS}`,
      {
        params,
        loader: false,
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const getEntityTypeCounts = (params = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.ENTITY_ISSUE_TYPE_COUNTS}`,
      {
        params,
        loader: false,
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const getCustomEntityList = (params = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.GET_TEMPLATE_LIST}`,
      {
        params,
        loader: false,
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const getAttributeList = ({ templateId, versionId } = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.GET_ATTRIBUTES}`,
      {
        params: { template_id: templateId, version_id: versionId },
        loader: false,
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const getAttributeListData = ({ entityId } = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.ATTRIBUTE_DETAILS}`,
      { params: { entity_id: entityId }, loader: false }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const getEntitySectionPermissions = ({ entityId } = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.SECTION_PERMISSIONS}`,
      { params: { entityId }, loader: false }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const getSingleEntity = ({ templateId, versionId } = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.GET_SINGLE_ENTITY}`,
      {
        params: { template_id: templateId, version_id: versionId },
        loader: false,
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const getTeamDetails = ({
  entityId,
  recentMembersLimit = null,
} = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.TEAM_DETAILS}`,
      {
        params: {
          entityId,
          ...(recentMembersLimit !== null && {
            recent_members_limit: recentMembersLimit,
          }),
        },
        loader: false,
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const getGroupDetails = ({ entityId, entityType } = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GROUP_DETAILS}`,
      {
        params: { entity_id: entityId, entity_type: entityType },
        loader: false,
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const getSingleEntityDetails = ({ entityId } = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_SINGLE_ENTITY}`,
      { params: { entityId }, loader: false }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const getUserRolePermissions = ({ entityId } = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_USER_ROLE_PERMISSIONS}`,
      { params: { entity_id: entityId }, loader: false }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const getArtifactProcessStatus = ({ entityId } = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.ARTIFACT_PROCESS_STATUS}`,
      { params: { entity_id: entityId }, loader: false }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const getToolbarById = ({ entityId } = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CNF.DYT.GET_TEMPLATE_BY_ID}/${entityId}`,
      { loader: false }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const getModelPreviousState = ({ entityId } = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_MODEL_PREVIOUS_STATE}`,
      { params: { entityId }, loader: false }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const getAlertEvents = ({ entityId } = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.ALERT_EVENT}`,
      { params: { entityId }, loader: false }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const getApprovalDetails = ({ entityId } = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_APPROVAL_DETAILS}`,
      { params: { entity_id: entityId }, loader: false }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const getWorkflowCheckList = ({ entityId } = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.WORKFLOW_CHECKLIST}`,
      { params: { entityId }, loader: false }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const changeWorkflowCheckList = ({
  checkList = [],
  entityId = '',
} = {}) => {
  return axios
    .post(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.WORKFLOW_CHECKLIST}`,
      { entityId, checkList },
      { loader: false }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const getShowInSummary = ({ entityId, sectionName } = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_SHOW_IN_SUMMARY}`,
      {
        params: { entityId, summary_section_name: sectionName },
        loader: false,
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const getVersions = ({ entityId } = {}) => {
  const res = axios.get(
    `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_VERSIONS}`,
    {
      params: { entity_id: entityId },
      loader: false,
    }
  );
  return res;
};

export const createVersion = (body) => {
  return axios.post(
    `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.CREATE_VERSION}`,
    {
      params: body,
    },
    { loader: false }
  );
};

export const rollbackVersion = (body) => {
  return axios.post(
    `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.ROLLBACK_VERSION}`,
    {
      params: body,
    },
    { loader: false }
  );
};

export const getVersionsComparison = (params = {}) => {
  const res = axios.get(
    `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.VERSIONS_COMPARISON}`,
    {
      params,
      loader: false,
    }
  );
  return res;
};

export const getActionables = ({ entityId, limit } = {}) => {
  const res = axios.get(
    `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CNF.ACT.GET_ACTIONABLES}`,
    {
      params: {
        entity_uuid: entityId,
        page_size: limit,
      },
      loader: false,
    }
  );
  return res;
};

export const getDraftAttributeValue = (params = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.SAVE_DRAFT}`,
      { params, loader: false }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const setDraftAttributeValue = (payload = {}) => {
  return axios
    .post(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.SAVE_DRAFT}`,
      payload,
      { loader: false }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const getOverrideAttributeValue = (params = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_OVERRIDE_ATTRIBUTE_VALUE}`,
      { params, loader: false }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const updateModelEntity = (body = {}) => {
  return axios
    .post(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.UPDATE_MODEL}`,
      body,
      { loader: false }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const getEntityStatus = ({ entityId } = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_CURRENT_STATES}`,
      {
        params: { entityId },
        loader: false,
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const getHistory = ({ entity_id } = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.DRAFT_HISTORY}`,
      { params: { entity_id }, loader: false }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const normalizeDraftHistoryData = (data) => {
  if (Array.isArray(data?.activity_blocks)) {
    return [{ activity_blocks: data.activity_blocks }];
  }
  if (Array.isArray(data)) {
    return data;
  }
  if (Array.isArray(data?.history)) {
    return data.history;
  }
  if (Array.isArray(data?.payload)) {
    return data.payload;
  }
  if (Array.isArray(data?.data)) {
    return data.data;
  }
  return [];
};

export const getIsCycleProcessEnabled = ({
  parentEntityTemplateId,
  parentEntityTemplateVersionId,
  associatedEntityTemplateId,
} = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.IS_CYCLE_PROCESS_ENABLED}`,
      {
        params: {
          parent_entity_template_version_id: parentEntityTemplateVersionId,
          parent_entity_template_id: parentEntityTemplateId,
          associated_entity_template_id: associatedEntityTemplateId,
        },
        loader: false,
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const updateArtifactCycleCount = ({
  entityId,
  entityType,
  cycle,
  parentEntityId,
  parentEntityType,
} = {}) => {
  return axios
    .post(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.UPDATE_ARTIFACT_CYCLE}`,
      {
        entity_id: entityId,
        entity_type: entityType,
        cycle: cycle,
        parent_entity_id: parentEntityId,
        parent_entity_type: parentEntityType,
      },
      { loader: false }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const getCycleProcessDetails = ({
  entityId,
  templateName,
  entityType,
} = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.CYCLE_SIDEBAR_DATA}`,
      {
        params: {
          entity_id: entityId,
          template_name: templateName,
          entity_type: entityType,
        },
        loader: false,
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const getIssueTypesInfo = ({
  entityId,
  relation,
  subtype,
  template,
  page,
  pageSize,
} = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.ISSUE_DATA}`,
      {
        params: {
          entityId,
          relation,
          subtype,
          template,
          page,
          page_size: pageSize,
        },
        loader: false,
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const getWorkflowDrawerDetails = ({ entityId, state } = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.WORKFLOW_LIFE_CYCLE_STAGE_DETAILS}`,
      {
        params: {
          entityId,
          state,
        },
        loader: false,
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const getAttributeSourceMapping = ({
  entity_id = '',
  entity_type = '',
} = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_ATTRIBUTE_SOURCE_MAPPING}`,
      {
        params: { entity_id, entity_type },
        loader: false,
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const getOngoingProcesses = ({ entityId } = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_ONGOING_PROCESSES}`,
      {
        params: { entity_id: entityId },
        loader: false,
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
